import { useEffect, useRef } from "react";
import { ospThemes } from "@ospweb/sdk-ui";
import NextImage from "../NextImage";
import { createEasyLineChart } from "../createChart";
import Translations from "@translate/components/Home/PivotAlertItem";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const PivotAlertItem = (props: {
  data: {
    logo: string;
    base: string;
    price: string;
    chatData: number[];
    ticks: { x: number; color: string }[];
  };
  isKorean: boolean;
}) => {
  const {
    data: { logo, base, price, chatData, ticks },
    isKorean,
  } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    createEasyLineChart({
      data: chatData,
      el: ref.current,
      ticks,
      lineColor: ospThemes.colors.border_white_solid,
      shadow: true,
    });
  }, [chatData, ticks]);

  return (
    <div className="flex gap-2 items-center justify-between">
      <div className="flex gap-2">
        <NextImage
          src={logo}
          alt="Pivot Alert"
          width={24}
          height={24}
          className="w-6 h-6 rounded-full"
        />
        <div>
          <div className="body_medium_m text-content_primary">{base}</div>
          <div className="body_s text-content_tertiary">
            {`${isKorean ? "" : "$"}${price}`}
            {isKorean ? (
              <span className="text-content_tertiary body_xs ml-[2px]">
                {I18n.t("KRW")}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div ref={ref} className="w-[100px] h-[31px]" />
    </div>
  );
};
